// extracted by mini-css-extract-plugin
export default {"form":"NewTodo_form__NH2Wd"};